(function ($) {
	// On Dom Ready
	$(function () {
		// Swiper slider
		const slider_element_selector = ".featured-industries-wrapper .swiper";

		// disable if only one slide
		if ($(slider_element_selector).find(".swiper-slide").length > 1) {
			const the_slider = new Swiper(slider_element_selector, {
				loop: true,
				lazy: true,
				slidesPerView: "auto",
				spaceBetween: 30,

				autoplay: {
					delay: 3000,
				},
				speed: 700,

				// If we need pagination
				pagination: false,

				// Navigation arrows
				navigation: false,
			});
		} else {
			$(slider_element_selector).addClass("disabled");
		}
	});
})(jQuery);
